module.exports = __webpack_public_path__ + "static/media/square.b22cc730.png";